export const SET_GET_ROOM_LABELS_PENDING = 'SET_GET_ROOM_LABELS_PENDING'
export const SET_ROOMS_LABELS = 'SET_ROOMS_LABELS'
export const SET_GET_ROOM_LABELS_ERROR = 'SET_GET_ROOM_LABELS_ERROR'
export const SET_DISPLAY_TYPE = 'SET_DISPLAY_TYPE'
export const SET_SUBSCRIPTION_LABELS_PENDING = 'SET_SUBSCRIPTION_LABELS_PENDING'
export const SET_SUBSCRIPTION_LABELS = 'SET_SUBSCRIPTION_LABELS'
export const SET_SUBSCRIPTION_LABELS_ERROR = 'SET_SUBSCRIPTION_LABELS_ERROR'
export const SET_DATA_ROOM_PRICING_PENDING = 'SET_DATA_ROOM_PRICING_PENDING'
export const SET_DATA_ROOM_PRICING = 'SET_DATA_ROOM_PRICING'
export const SET_DATA_ROOM_PRICING_ERROR = 'SET_DATA_ROOM_PRICING_ERROR'
export const SET_DATA_ROOM_CUSTOM_PRICING_PENDING = 'SET_DATA_ROOM_CUSTOM_PRICING_PENDING'
export const SET_DATA_ROOM_CUSTOM_PRICING = 'SET_DATA_ROOM_CUSTOM_PRICING'
export const SET_DATA_ROOM_CUSTOM_PRICING_ERROR = 'SET_DATA_ROOM_CUSTOM_PRICING_ERROR'
export const SET_LAST_VISITED_ROOMS = 'SET_LAST_VISITED_ROOMS'
export const SET_LAST_VISITED_ROOMS_PENDING = 'SET_LAST_VISITED_ROOMS_PENDING'
export const SET_RECENT_ROOMS_PENDING = 'SET_RECENT_ROOMS_PENDING'
export const SET_RECENT_ROOMS = 'SET_RECENT_ROOMS'
export const SET_RECENT_ROOMS_ERROR = 'SET_RECENT_ROOMS_ERROR'
export const SET_SEARCH_MODE_ENABLED = 'SET_SEARCH_MODE_ENABLED'
export const SET_PM_ROOMS_PENDING = 'SET_PM_ROOMS_PENDING'
export const SET_PM_ROOMS = 'SET_PM_ROOMS'
export const SET_PM_ROOMS_PAGINATION = 'SET_PM_ROOMS_PAGINATION'
export const SET_PM_ROOMS_ERROR = 'SET_PM_ROOMS_ERROR'
export const SET_GUEST_ROOMS_PENDING = 'SET_GUEST_ROOMS_PENDING'
export const SET_GUEST_ROOMS = 'SET_GUEST_ROOMS'
export const SET_GUEST_ROOMS_ERROR = 'SET_GUEST_ROOMS_ERROR'
export const SET_GUEST_ROOMS_PAGINATION = 'SET_GUEST_ROOMS_PAGINATION'
export const SET_EXISTING_ROOMS_LABELS_PENDING = 'SET_EXISTING_ROOMS_LABELS_PENDING'
export const SET_EXISTING_ROOMS_LABELS = 'SET_EXISTING_ROOMS_LABELS'
export const SET_EXISTING_ROOMS_LABELS_ERROR = 'SET_EXISTING_ROOMS_LABELS_ERROR'
export const SET_BASE_QUERY_PARAMS_PM = 'SET_BASE_QUERY_PARAMS_PM'
export const SET_BASE_QUERY_PARAMS_GUEST = 'SET_BASE_QUERY_PARAMS_GUEST'
export const SET_PM_ABORT_CONTROLLER = 'SET_PM_ABORT_CONTROLLER'
export const SET_GUEST_ABORT_CONTROLLER = 'SET_GUEST_ABORT_CONTROLLER'
export const RESET_ALL_PM_ROOMS_STATE = 'RESET_ALL_ROOMS_STATE'
export const RESET_ALL_GUEST_ROOMS_STATE = 'RESET_ALL_GUEST_ROOMS_STATE'
